//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateCondicionesComerciales } from "@/typings/store/plugins/easyFirestore/condicionesComerciales";

const getters: GetterTree<StateCondicionesComerciales, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const condicionesComerciales = {
    firestorePath: "dev/v1/condicionesComerciales",
    firestoreRefType: "collection",
    moduleName: "condicionesComerciales",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default condicionesComerciales;
